// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__EQUoF","lastWrapper":"index_lastWrapper__CAbmp","icon":"index_icon__YEeGR","hrefHover":"index_hrefHover__F37_Z","textList":"index_textList__2Vhds"};